import { render, staticRenderFns } from "./dealer_customer_select.vue?vue&type=template&id=7c060bc6&"
import script from "./dealer_customer_select.vue?vue&type=script&lang=js&"
export * from "./dealer_customer_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports